export default __webpack_public_path__ + "static/media/down-arrow.2141421c.svg";